<script lang="ts">
import { defineComponent, h } from 'vue';

import { classNames } from '@components/utils';

import { makeAlignProps, makeTagProps, useRender } from '../../composable';

export const componentName = 'CdsCardActions';
export default defineComponent({
  name: componentName,
  props: {
    ...makeTagProps(),
    ...makeAlignProps()
  },
  setup(props, { slots }) {
    useRender(() =>
      h(
        props.tag,
        {
          class: classNames('cds-card-actions', {
            [`cds-card-actions--align-${props.align}`]: props.align
          })
        },
        slots.default?.()
      )
    );

    return {};
  }
});
</script>
